import React, {
  useEffect,
  useMemo,
  useState,
  useCallback,
  useRef,
  useContext,
} from 'react'
import { connect } from 'react-redux'

import PropTypes from 'prop-types'
import ButtonGroup from '@material-ui/core/ButtonGroup'
import { getCountries } from 'Reducers/Countries/actions'
import { getCities as getCitiesRedux } from 'Reducers/City/actions'
import { Col, Row } from 'react-bootstrap'
import { authorization } from 'Module/Auth/Auth'
import { Input } from './../../../../Components/Form/Input'

import { SectionTitle } from './../../../../Components/Section/SectionTitle'
import { SectionWrapper } from './../../../../Components/Section/SectionWrapper'
import { SelectDashboard } from './../../../../Components/Form/SelectDashboard'
import SubmitButton from './../../../../Components/Form/SubmitButton'
import Switch from './../../../../Components/Form/Switch'
import { Slider } from './../../../../Components/Form/Slider'
import { Checkbox } from './../../../../Components/Form/Checkbox'
import { getInitialOverlaysMapFromMissions } from '../../../LetterboxMissions/util.js'
import { SnackBarContext } from './../../../../Components/SnackBar'
import {
  STATUS_CAMPAIGN_ENUM_DRAFT,
  STATUS_CAMPAIGN_ENUM_ACTIVE,
  STATUS_CAMPAIGN_ENUM_ARCHIVE,
  STATUS_CAMPAIGN_ENUM_COMPLETED,
  CAMPAIGN_ENUM_TYPES,
  CITY_STATUS_ENUM_ACTIVE,
  CAMPAIGN_LOG_ENUM_TYPES,
  GOAL_CAMPAIGN_OPTIONS,
  CAMPAIGN_INTERNAL_STATUSES,
  CAMPAIGN_SUBTYPES_ENUM,
  INDUSTRY_GROUPS_OPTIONS_TYPES_V2,
  INDUSTRY_OPTIONS_TYPES_V2,
} from '../../../../shared/constants'
import {
  showReduxModal,
  hideReduxModal,
  toggleConfirmAvailabilityReduxModal,
  resetReduxModal,
} from '../../../../Reducers/UI/actions'
import CampaignBuilderMap from '../../../Campaigns/CreateEditCampaign/CampaignBuilderMap/CampaignBuilderMap'
import LoadingIndicator from '../../../../Components/LoadingIndicator/LoadingIndicator'
import CampaignQuote from '../../../../Components/CampaignQuote/container/CampaignQuote'
import { getOverlayBoundary } from '../../../../Components/DrawMap/util'
import exportComponentAsPDF from '../../../../Utils/ExportComponentAsPDF'
import CampaignPrintingPlan from './CampaignPrintingPlan'
import MetricsEdit from './../../../../Components/MetricsEdit'
import MetricsInWorkflow from './../../../../Components/MetricsInWorkflow'
import {
  convertMonetaryDollarStringToCentValue,
  convertCentValueToMonetaryString,
} from './../../../../Utils/Formatters'
import {
  runValidation as runValidationShared,
  isRequired,
} from './../../../../shared/validation'
import { ErrorMessage } from './../../../../Components/Form/ErrorMessage'
import { isPathFinderSupportsCountry } from '../../../../shared/libraries/geo'
import SquareCheckBox from '../../../../Assets/Images/icons/squareCheckBox'
import { SectionLabel } from '../../../../Components/Section'
import CityMetricTable from '../../../../Components/CityMetricTable'
import { updateCampaignExtraData } from '../../../Campaigns/Page/Codes/gql/updateCampaignInternalStatus'
import { TextField } from 'material-ui'
import DatePicker from 'material-ui/DatePicker'
import CalendarIcon from 'Assets/Images/icons/calendar'
import { format } from 'date-fns'
import {
  checkIsCityMetricsDifferent,
  formatDateToEndOfDay,
  getLogs,
  navigateToArtworks,
  sendEmailChangeCityMetricToGMsAndCFOC,
} from './util'
import { insertCampaignLogs } from '../../../../Logs/campaign/gql'

import ImportCityMetrics from './ImportCityMetrics'

import { downloadStringAsFile } from '../../../../Utils/Misc'
import { Modal } from '../../../../Components/Modal'
import { apiXero } from '../../../../Module/API/Xero'
import { onCreateXeroItem } from '../../../Campaigns/CreateEditCampaign/util'
import { openLinkInNewTab } from '../../../Country/Page/Pipeline/PipelineView/utils'
import { PATHS } from '../../../../Config/Routing/paths'
import XeroConnected from '../../../../Components/XeroConnected'
import { isProduction } from '../../../../Utils/Functions'
import { getCities as getCitiesGQL } from '../../../../Module/graphQL'
import ActivateCampaignModal from './Modals/ActivateCampaignModal'
import BonusChangesModal from './Modals/BonusChangesModal'
import LaunchDateChangeDialog from './Modals/LaunchDateChangeDialog'
import CampaignShipmentUpload from '../../../../Components/CampaignShipmentUpload'
import { CONFIG } from '../../../../Config/config.js'
import CampaignFeaturesConfig, {
  cityMetricsTypes,
} from './CampaignFeaturesConfig.js'
import AffiliateMetricTable from '../../../../Components/AffiliateMetricTable/index.js'
import { apiClient } from '../../../../Module/API/Client.js'
import { calculateTotalCostDependingOfType } from '../../../../Components/CityMetricTable/utils.js'
import { useWrappedPosthog } from '../../../../Components/PostHogProvider/hooks.js'

import { Tooltip } from '@material-ui/core'
import InfoIcon from '@material-ui/icons/Info'
import CampaignTargetingEdit from '../../../../Components/CampaignTargetingEdit/index.js'
import { updateClientById, getClients } from 'Reducers/Clients/actions'
import FillClientIndustryModal from './Modals/FillClientIndustryModal.js'
// Define the form validation
/**
 * Run validation over a function, can pass it a dto and it will return any
 * error messages if the field isn't valid else will return null
 */

const isClient = () => authorization.isClient() || authorization.isClientAdmin()

/**
 * @typedef Client
 * @property {string} name
 * @property {string} id
 *
 * @typedef Country
 * @property {string} name
 * @property {string} id
 *
 * @typedef CreateEditCampaignFormProps
 * @property {string} type One of either 'HANDTOHAND', 'LETTERBOX' or ;DIRECTMAIL. See
 * CAMPAIGN_ENUM_TYPES
 * @property {boolean} bonusEnabled
 * @property {string} status One of either 'DRAFT', 'ACTIVE', 'ARCHIVED'
 * @property {string} clientId The campaign client id, this is only changable
 * in create mode.
 * @property {Array<Client>} clients The selectable clients when creating a
 * campaign. If in edit mode ensure it at least contains the client for the
 * campaign. Only pass in active clients.
 * @property {string} countryId The campaign country id, this is only changable
 * in create mode.
 * @property {Array<Country>} countries The selectable countries when creating a
 * campaign. If in edit mode ensure it at least contains the country for the
 * campaign.
 * @property {string} name The campaign name
 * @property {number} printingCostPerFlyer The printing cost per flyer in cents.
 * @property {number} baRedemptionPeriod The BA redemption period in weeks.
 * @property {string} pitchUrl
 * @property {number} basePayout The base payout in cents.
 * @property {number} distributionCost The distribution cost in cents.
 * @property {number} payoutPerConversion The bonus payout per conversion in
 * cents
 * @property {number} bonusLimit The upper limit on bonuses that can be
 * paid out in cents.
 * @property {?} overlaysMap
 *
 * @param {CreateEditCampaignFormProps} props
 */
const CreateEditCampaignFormUnstyled = props => {
  const { editMode, getCampaignCityMetricsData, targeting } = props
  const runSnackBar = useContext(SnackBarContext)
  const initialValues = {
    ...props,
    printingCostPerFlyer: convertCentValueToMonetaryString(
      props.printingCostPerFlyer,
    ),
    basePayout: convertCentValueToMonetaryString(props.basePayout),
    distributionCost: convertCentValueToMonetaryString(props.distributionCost),
    payoutPerConversion: convertCentValueToMonetaryString(
      props.payoutPerConversion,
    ),
    bonusLimit: convertCentValueToMonetaryString(props.bonusLimit),
    startDate: props.startDate
      ? (() => {
          const utcDate = new Date(Number(props.startDate))
          const year = utcDate.getUTCFullYear()
          const month = utcDate.getUTCMonth()
          const day = utcDate.getUTCDate()
          return new Date(year, month, day)
        })()
      : null,
    offerExpirationDate: props.offerExpirationDate
      ? new Date(Number(props.offerExpirationDate)).valueOf()
      : null,
    campaignDurationWeek: props.campaignDurationWeek,
    noExpiration: props.noExpiration,
    conversionsApiEnabled: props.conversionsApiEnabled,
    scanDataEnabled: props.scanDataEnabled,
    isFlyerCodeRequired: props.isFlyerCodeRequired,
    name: props.name,
    goal: props.campaign && props.campaign.goal ? props.campaign.goal : [],
    clientId: props.clientId || null,
    countryId: props.countryId || null,
    bonusThreshold: props.bonusThreshold,
    purchaseOrderNumber: props.purchaseOrderNumber,
    // Targeting defaults
    targetType: targeting ? targeting.type : null,
    targetGender: targeting ? targeting.gender : null,
    targetIncome: targeting ? targeting.income : [],
    targetAgeGroups: targeting ? targeting.ageGroups : [],
    applyNicheTargeting: targeting ? targeting.applyNiche : false,
    nicheTargetingDescription: targeting ? targeting.nicheDescription : '',
  }
  const user = authorization.getUser()

  // Form values, anything that gets updated will end up in here
  const [errors, setErrors] = useState({})
  const [values, setValues] = useState({})

  const {
    type,
    bonusEnabled,
    status,
    clientId,
    countryId,
    name,
    printingCostPerFlyer,
    baRedemptionPeriod,
    pitchUrl,
    basePayout,
    distributionCost,
    payoutPerConversion,
    bonusLimit,
    overlaysMap,
    prebuiltOverlays,
    startDate,
    offerExpirationDate,
    noExpiration,
    conversionsApiEnabled,
    scanDataEnabled,
    isFlyerCodeRequired,
    campaignDurationWeek,
    goal,
    bonusThreshold,
    purchaseOrderNumber,
    targetType,
    targetGender,
    targetIncome,
    targetAgeGroups,
    applyNicheTargeting,
    nicheTargetingDescription,
  } = { ...initialValues, ...values }

  const { clients } = props

  const { disableBAFeatures, disableXeroInvoice } = CampaignFeaturesConfig(type)

  const [receiveReport, setReceiveReport] = useState(
    props.campaign ? props.campaign.receiveReport : true,
  )

  const [noExpirationState, setNoExpiration] = useState(false)
  const [citiesMetricsValues, setCitiesMetricsValues] = useState([])
  const [conversionToggle, setConversionToggle] = useState(false)
  const [scansToggle, setScansToggle] = useState(true)
  const [flyerCodeToggle, setFlyerCodeToggle] = useState(true)
  const [canMetricEdit, setCanMetricEdit] = useState(true)
  const [isPaymentSkipped, setIsPaymentSkipped] = useState(false)
  const [paymentSkippedBy, setPaymentSkippedBy] = useState('')
  const [uploadedCityMetrics, setUploadedCityMetrics] = useState(null)
  const [showImportCityMetricModal, setShowImportCityMetricModal] = useState(
    false,
  )
  const [tenant, setTenant] = useState(null)
  const [isTenantLoading, setIsTenantLoading] = useState(true)
  const [refetchTenant, setRefetchTenant] = useState(true)
  const [cities, setCities] = useState([])
  const [affiliateMetricsValues, setAffiliateMetricsValues] = useState([])
  const [isLaunchDateModalOpen, setLaunchDateModalOpen] = useState(false)

  const startDatePickerRef = useRef(null)
  const isXeroAvailable = apiXero.isHaveXeroAccess()

  const toggleReceiveReport = useCallback(async () => {
    setReceiveReport(receiveReport => !receiveReport)
  }, [])

  const toggleConversionApi = useCallback(async () => {
    setConversionToggle(conversionToggle => !conversionToggle)
  }, [])

  const toggleScans = useCallback(async () => {
    setScansToggle(scansToggle => !scansToggle)
  }, [])

  const toggleFlyerCode = useCallback(async () => {
    setFlyerCodeToggle(flyerCodeToggle => !flyerCodeToggle)
  }, [])

  const posthog = useWrappedPosthog()

  const isAimFeatureEnabled = posthog.useFeatureFlagEnabled(
    'is_aim_feature_enabled',
  )

  const setValue = (prop, value) => {
    setValues(values => ({ ...values, [prop]: value }))
  }

  const getCities = async params => {
    const response = await getCitiesGQL(params)
    const {
      data: { cities },
    } = await response.json()
    return cities.edges.map(({ node }) => node)
  }

  const getCountry = () =>
    (props.countries || []).find(country => country.id == countryId) || {}

  const country = useMemo(getCountry, [countryId, props.countries])

  const isUS = country.code === 'US' && CONFIG.US_TAXES_ENABLED

  const isUnitedStatesCoreDM = useMemo(
    () =>
      initialValues &&
      initialValues.campaign &&
      initialValues.type === CAMPAIGN_ENUM_TYPES.DIRECTMAIL &&
      isUS,
    [initialValues, country],
  )

  const fetchExistingAffiliateCostMetrics = async () => {
    if (props.campaign && props.campaign.id) {
      const response = await apiClient.getInsertsCostMetrics(props.campaign.id)
      const affiliateMetrics = await response.json()
      const affiliateMetricsWithTotal = calculateTotalCostDependingOfType(
        affiliateMetrics,
      )
      setAffiliateMetricsValues(affiliateMetricsWithTotal)
    }
  }

  const fetchData = async () => {
    await props.getCountries()
    await props.getCitiesRedux() // WORKAROUND TO UNBLOCK OPS

    if (countryId) {
      const cities = await getCities({
        countryId,
      })
      setCities(cities)
    }

    setNoExpiration(noExpiration)
    if (scanDataEnabled !== undefined && scanDataEnabled !== null) {
      setScansToggle(scanDataEnabled)
    }
    if (conversionsApiEnabled !== undefined && conversionsApiEnabled !== null) {
      setConversionToggle(conversionsApiEnabled)
    }
    if (isFlyerCodeRequired !== undefined && isFlyerCodeRequired !== null) {
      setFlyerCodeToggle(isFlyerCodeRequired)
    }
    if (
      props.campaign &&
      props.campaign.status &&
      props.campaign.status !== STATUS_CAMPAIGN_ENUM_DRAFT
    ) {
      setCanMetricEdit(false)
    }
  }

  useEffect(() => {
    fetchExistingAffiliateCostMetrics()
  }, [])

  useEffect(() => {
    fetchData()
  }, [countryId])

  useEffect(() => {
    if (
      props.campaign &&
      props.campaign.selfServeData &&
      props.campaign.selfServeData[0]
    ) {
      setIsPaymentSkipped(props.campaign.selfServeData[0].isPaymentSkipped)
      setPaymentSkippedBy(props.campaign.selfServeData[0].paymentSkippedBy)
    }
  }, [props.campaign])

  const isH2HType = type == CAMPAIGN_ENUM_TYPES.HANDTOHAND
  const isD2DType = type == CAMPAIGN_ENUM_TYPES.LETTERBOX
  const isDMType = type == CAMPAIGN_ENUM_TYPES.DIRECTMAIL
  const isAIMType = type == CAMPAIGN_ENUM_TYPES.INSERTS

  var runValidation = runValidationShared.bind(null, {
    clientId: isRequired,
    countryId: isRequired,
    name: isRequired,
    printingCostPerFlyer: isRequired,
    startDate: isRequired,
    campaignDurationWeek: isDMType ? () => {} : isRequired,
    offerExpirationDate: noExpirationState ? () => {} : isRequired,
    goal: isRequired,
    // Targeting validations
    targetType: isRequired,
    targetGender: targetType === 'B2C' ? isRequired : () => {},
    targetIncome:
      targetType === 'B2C'
        ? v => (v && v.length ? null : 'Required')
        : () => {},
    targetAgeGroups:
      targetType === 'B2C'
        ? v => (v && v.length ? null : 'Required')
        : () => {},
    nicheTargetingDescription:
      targetType === 'B2C' && applyNicheTargeting
        ? v => {
            if (!v || !v.trim()) return 'Required'
            return v.length <= 250 ? null : 'Max 250 characters'
          }
        : () => {},
  })

  const isUSDMSubtype =
    props.campaign &&
    (props.campaign.subtype === CAMPAIGN_SUBTYPES_ENUM.ADM ||
      props.campaign.subtype === CAMPAIGN_SUBTYPES_ENUM.EDDM)

  const isSelfServe = (props.campaign && props.campaign.isSelfServe) || false
  const isDraft =
    props.campaign &&
    props.campaign.selfServeData &&
    props.campaign.selfServeData[0] &&
    props.campaign.selfServeData[0].internalStatus ===
      STATUS_CAMPAIGN_ENUM_DRAFT

  const disableEditAffiliateMetrics =
    props.campaign &&
    props.campaign.type === CAMPAIGN_ENUM_TYPES.INSERTS &&
    props.campaign.selfServeData.length > 0 &&
    props.campaign.selfServeData[0].internalStatus !==
      CAMPAIGN_INTERNAL_STATUSES.DRAFT &&
    props.campaign.selfServeData[0].internalStatus !==
      CAMPAIGN_INTERNAL_STATUSES.UPLOAD_CODES

  const bonusDisabled =
    props.campaign &&
    ![STATUS_CAMPAIGN_ENUM_DRAFT, STATUS_CAMPAIGN_ENUM_ACTIVE].includes(
      props.campaign.status,
    )

  const bonusSwitchDisabled =
    editMode && props.campaign.status !== STATUS_CAMPAIGN_ENUM_DRAFT

  const client = useMemo(() => {
    return props.clients.find(client => client.id == clientId)
  }, [clientId, props.clients])

  const onClientUpdate = async (clientId, industry, industryGroup) => {
    return await props.updateClientById(
      { onSuccess: () => props.getClients() },
      clientId,
      {
        industry,
        industryGroup,
      },
    )
  }

  const ifClientHasValidIndustryAndIndustryGroup = client => {
    if (!client.industry || !client.industryGroup) return false

    const isIndustryGroupValid = Object.values(
      INDUSTRY_GROUPS_OPTIONS_TYPES_V2,
    ).includes(client.industryGroup)
    const isIndustryValid = Object.values(INDUSTRY_OPTIONS_TYPES_V2).includes(
      client.industry,
    )
    return isIndustryGroupValid && isIndustryValid
  }

  const clientIdChangeSideEffect = clientId => {
    const client = props.clients.find(client => client.id == clientId)

    if (!ifClientHasValidIndustryAndIndustryGroup(client)) {
      return props.showReduxModal({
        title: '',
        children: (
          <FillClientIndustryModal
            client={client}
            onConfirm={async (clientId, industry, industryGroup) => {
              await onClientUpdate(clientId, industry, industryGroup)
              props.hideReduxModal()
            }}
            onCancel={() => props.hideReduxModal()}
          />
        ),
        hideButtons: true,
        hideTitle: true,
      })
    }
  }

  useEffect(() => {
    if (clientId && !editMode) {
      clientIdChangeSideEffect(clientId)
    }
  }, [clientId])

  useEffect(() => {
    if (refetchTenant && isXeroAvailable && (editMode ? client : true)) {
      getXeroTenant()
      setRefetchTenant(false)
    }
  }, [refetchTenant, editMode, client])

  const renderClientSelect = () => {
    const { clients } = props
    if (props.editMode || !clients.length) {
      return (
        <div className="disabled-field">
          <label>Client</label>
          <span>{client ? client.name : '-'}</span>
        </div>
      )
    }

    return (
      <SelectDashboard
        options={clients
          .filter(
            client =>
              (countryId && client.countryId === parseInt(countryId, 10)) ||
              !countryId,
          )
          .map(dto => ({ label: dto.name, value: dto.id }))}
        value={clientId}
        onChange={(a, b, value) => {
          if (countryId) {
            setValue('clientId', value)
          } else {
            const { countryId } = clients.find(client => client.id === value)
            setValues(values => ({ ...values, clientId: value, countryId }))
          }
          setRefetchTenant(true)
        }}
        label="Client*"
        sorted={true}
        error={errors['clientId']}
        cypress_id="create-campaign-client-select"
      />
    )
  }

  const getEnabledCountries = (countries, campaignType) => {
    const supportedCountries = CampaignFeaturesConfig(campaignType)
      .supportedCountryCodes

    if (supportedCountries && supportedCountries.length) {
      if (supportedCountries[0] === 'ALL') {
        return countries
      }
      return countries.filter(c => supportedCountries.includes(c.code))
    }

    return countries
  }

  const renderCountrySelect = useCallback(() => {
    if (props.editMode) {
      const country = props.countries.find(country => country.id == countryId)
      return (
        <div className="disabled-field">
          <label>Country</label>
          <span>{country ? country.name : '-'}</span>
        </div>
      )
    }

    return (
      <SelectDashboard
        options={getEnabledCountries(props.countries, type).map(dto => ({
          label: dto.name,
          value: String(dto.id),
        }))}
        value={String(countryId)}
        onChange={(a, b, value) => setValue('countryId', value)}
        label="Country*"
        sorted={true}
        error={errors['countryId']}
        cypress_id="create-campaign-country-select"
      />
    )
  }, [props.editMode, props.countries, type, countryId, errors['countryId']])

  const [dropdownStatus, setDropdownStatus] = useState({
    current: props.status,
    archived: false,
  })

  const renderStatusSelect = () => {
    const { editMode } = props
    if (!editMode) return null

    const selectOptions = [
      {
        label: 'Active',
        value: STATUS_CAMPAIGN_ENUM_ACTIVE,
      },
      {
        label: 'Archived',
        value: STATUS_CAMPAIGN_ENUM_ARCHIVE,
      },
      {
        label: 'Completed',
        value: STATUS_CAMPAIGN_ENUM_COMPLETED,
      },
    ]

    if (status === STATUS_CAMPAIGN_ENUM_DRAFT) {
      selectOptions.push({
        label: 'Draft',
        value: STATUS_CAMPAIGN_ENUM_DRAFT,
      })
    }

    const filteredOptions = isAIMType
      ? selectOptions.filter(
          option =>
            option.value === STATUS_CAMPAIGN_ENUM_ARCHIVE ||
            option.value === dropdownStatus.current,
        )
      : selectOptions

    const handleStatusChange = (a, b, value) => {
      if (isAIMType) {
        if (value === STATUS_CAMPAIGN_ENUM_ARCHIVE) {
          setDropdownStatus(prev => ({
            ...prev,
            archived: true,
          }))
        } else {
          setDropdownStatus({
            current: value,
            archived: false,
          })
        }
        setValue('status', value)
      } else {
        setValue('status', value)
      }
    }

    return (
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: '8px',
          width: '100%',
        }}
      >
        <div style={{ flex: 1 }}>
          <SelectDashboard
            onChange={handleStatusChange}
            options={filteredOptions}
            label="Status*"
            value={status}
            error={errors['status']}
            cypress_id="edit-campaign-status-select"
          />
        </div>
        {isAIMType && (
          <Tooltip
            title="Inserts campaigns can only be manually moved to Archived — Active and Completed statuses are set automatically."
            placement="right"
          >
            <InfoIcon
              style={{
                color: '#666',
                fontSize: '20px',
                cursor: 'help',
                marginTop: '24px',
              }}
            />
          </Tooltip>
        )}
      </div>
    )
  }
  const getCurrencyInputClass = () => {
    let currencySign
    if (countryId) {
      let country = (props.countries || []).find(({ id }) => id === countryId)
      if (country) {
        currencySign = country.currency
      }
    }

    switch (currencySign) {
      case '$':
        return 'input-with-icon_currency_dollar'
      case '€':
        return 'input-with-icon_currency_euro'
      case '£':
        return 'input-with-icon_currency_pound'
      case 'CHF':
        return 'input-with-icon_currency_chf'
      default:
        return ''
    }
  }

  const getCurrencySign = () => {
    if (countryId) {
      let country = (props.countries || []).find(({ id }) => id === countryId)

      if (country) {
        return country.currency
      }
    }
  }

  const hasStartDateChanged = useMemo(() => {
    const currentDate = new Date(startDate)
    const originalDate = new Date(Number(props.startDate))

    const originalLocalDate = new Date(
      originalDate.getUTCFullYear(),
      originalDate.getUTCMonth(),
      originalDate.getUTCDate(),
    )
    return (
      editMode &&
      props.campaign &&
      startDate &&
      props.startDate &&
      (currentDate.getFullYear() !== originalLocalDate.getFullYear() ||
        currentDate.getMonth() !== originalLocalDate.getMonth() ||
        currentDate.getDate() !== originalLocalDate.getDate())
    )
  }, [editMode, props.campaign, startDate, props.startDate])

  const currencySign = useMemo(getCurrencySign, [countryId, props.countries])

  const handleSubmit = async () => {
    const insertsFormattedCostMetrics = affiliateMetricsValues
      .map(data => {
        delete data.totalCost
        delete data.subTotal
        if (data.id && data.id.includes('newAffiliate')) {
          data.id = null
        }
        return data
      })
      .filter(item => item.clientId)

    const formattedCityMetrics = citiesMetricsValues
      .map(data => {
        delete data.totalCost
        return data
      })
      .filter(item => item.cityId)

    const shouldEnableReceiveReport = disableBAFeatures ? false : receiveReport // Only enable for BA related campaigns

    var values = {
      type,
      bonusEnabled,
      status,
      clientId,
      countryId,
      name: name.trim(),
      printingCostPerFlyer: convertMonetaryDollarStringToCentValue(
        printingCostPerFlyer,
      ),
      baRedemptionPeriod: Number(baRedemptionPeriod),
      pitchUrl,
      basePayout: basePayout,
      distributionCost,
      payoutPerConversion,
      bonusLimit: bonusLimit,
      overlaysMap,
      receiveReport: shouldEnableReceiveReport,
      startDate: startDate
        ? (() => {
            const year = startDate.getFullYear()
            const month = startDate.getMonth()
            const day = startDate.getDate()
            return new Date(Date.UTC(year, month, day, 0, 0, 0, 0))
          })()
        : null,
      campaignDurationWeek: isDMType ? null : campaignDurationWeek,
      offerExpirationDate: offerExpirationDate
        ? formatDateToEndOfDay(offerExpirationDate)
        : null,
      noExpiration: noExpirationState,
      conversionsApiEnabled: conversionToggle,
      scanDataEnabled: scansToggle,
      isFlyerCodeRequired: flyerCodeToggle,
      citiesMetrics: formattedCityMetrics,
      goal,
      xeroItemCodeForCreateCreateData: tenant
        ? { countryCode: country.code, tenantId: tenant.tenantId }
        : null,
      bonusThreshold,
      purchaseOrderNumber,
      insertsCostMetrics: insertsFormattedCostMetrics,
      // Targeting
      targeting: {
        targetType,
        targetGender,
        targetIncome,
        targetAgeGroups,
        applyNicheTargeting,
        nicheTargetingDescription: nicheTargetingDescription
          ? nicheTargetingDescription.trim()
          : '',
      },
    }

    const logs = []

    if (props.campaign) {
      const campaignId = props.campaign.id

      const logsData = getLogs({ campaignId, initialValues, values })
      logs.push(...logsData)

      const {
        ifCityMetricsDifferent,
        oldCM,
        newCM,
      } = checkIsCityMetricsDifferent({
        newCityMetrics: citiesMetricsValues,
        oldCityMetrics: props.campaignCityMetrics,
      })

      if (
        editMode &&
        ifCityMetricsDifferent &&
        isProduction() &&
        (!tenant || (tenant && tenant.invoice))
      ) {
        const citiesHashMap = cities.reduce((acc, city) => {
          if (city.country.id === countryId) {
            acc[city.id] = city.name
          }

          return acc
        }, {})

        const country = props.countries.find(({ id }) => id === countryId)

        await sendEmailChangeCityMetricToGMsAndCFOC({
          newCityMetric: newCM,
          oldCityMetrics: oldCM,
          isDM: isDMType,
          country,
          citiesHashMap,
          user,
        })
      }
    }
    setErrors([])

    await props.onSubmit(values)

    if (hasStartDateChanged && isUSDMSubtype) {
      await triggerDMAssetRegeneration({
        campaignId: props.campaign.id,
        subtype: props.campaign.subtype,
        oldStartDate: new Date(Number(props.startDate)),
        newStartDate: startDate,
      })
    }

    if (logs.length) {
      await insertCampaignLogs(logs)
    }

    if (editMode) {
      runSnackBar({
        type: 'success',
        msg: 'All set! Your changes have been saved',
      })
    }
    return
  }

  const onSubmit = async e => {
    const { showReduxModal } = props

    e.stopPropagation()
    e.preventDefault()
    const fieldsToValidate = { ...initialValues, ...values }
    var lErrors = runValidation(fieldsToValidate)

    if (Object.values(lErrors).filter(v => v).length) return setErrors(lErrors)

    if (hasStartDateChanged && isUSDMSubtype) {
      setLaunchDateModalOpen(true)
      return
    }

    const clientForCheck = props.clients.find(client => client.id == clientId)
    if (
      !ifClientHasValidIndustryAndIndustryGroup(clientForCheck) &&
      !editMode
    ) {
      return clientIdChangeSideEffect(clientForCheck.id)
    }

    const campaignActivating =
      props.status == STATUS_CAMPAIGN_ENUM_DRAFT &&
      status == STATUS_CAMPAIGN_ENUM_ACTIVE

    if (campaignActivating) {
      const hasArtworks = props.artworksLean && props.artworksLean.length > 0
      const hasInventoryConnectedToArtworks = props.artworksLean.some(
        artwork => artwork.inventoryCount > 0,
      )
      if (!hasArtworks || !hasInventoryConnectedToArtworks) {
        return showReduxModal({
          title: `Campaign can't be activated yet`,
          children: !hasArtworks ? (
            <span>
              This campaign doesn't have any artworks. To activate it, you'll
              need to create them first — then link them to a flyer pack.
            </span>
          ) : (
            <span>
              This campaign doesn't have any inventory connected to artworks. To
              activate it, you'll need to connect some inventory to the
              artworks.
            </span>
          ),
          onConfirm: () => navigateToArtworks(props.campaign.id),
          confirmLabel: !hasArtworks
            ? 'Create Artwork & Offers'
            : 'Go to artworks',
          submitButtonCypressId: 'confirm-artworks-and-inventory',
        })
      }
    }

    if (
      props.status == STATUS_CAMPAIGN_ENUM_DRAFT &&
      status == STATUS_CAMPAIGN_ENUM_ACTIVE
    ) {
      return showReduxModal({
        title: 'Activate Campaign',
        onConfirm: () => handleSubmit(),
        children: (
          <ActivateCampaignModal
            metrics={props.metrics}
            primaryMetricIndex={props.primaryMetricIndex}
            countryId={countryId}
            countries={props.countries}
            toggleConfirmAvailabilityReduxModal={
              props.toggleConfirmAvailabilityReduxModal
            }
            payoutPerConversion={payoutPerConversion}
            bonusLimit={bonusLimit}
            bonusEnabled={bonusEnabled}
            baRedemptionPeriod={baRedemptionPeriod}
            bonusThreshold={bonusThreshold}
            printingCostPerFlyer={printingCostPerFlyer}
          />
        ),
        confirmDisabled: true,
        confirmLabel: 'Activate campaign',
        submitButtonCypressId: 'activate-campaign-submit-button',
      })
    }

    const wasBonusAllowanceChanged =
      values.bonusLimit && values.bonusLimit !== initialValues.bonusLimit
    const wasPayoutPerConversionChanged =
      values.payoutPerConversion &&
      values.payoutPerConversion !== initialValues.payoutPerConversion
    const wasBonusThresholdChanged =
      values.hasOwnProperty('bonusThreshold') &&
      values.bonusThreshold != initialValues.bonusThreshold

    const wasBonusFieldsChanged =
      wasBonusAllowanceChanged ||
      wasPayoutPerConversionChanged ||
      wasBonusThresholdChanged
    if (
      props.status == STATUS_CAMPAIGN_ENUM_ACTIVE &&
      status == STATUS_CAMPAIGN_ENUM_ACTIVE &&
      wasBonusFieldsChanged
    ) {
      return showReduxModal({
        title: 'Bonus was changed',
        onConfirm: () => {
          handleSubmit()
        },
        children: (
          <BonusChangesModal
            toggleConfirmAvailabilityReduxModal={
              props.toggleConfirmAvailabilityReduxModal
            }
            country={country}
            wasBonusAllowanceChanged={wasBonusAllowanceChanged}
            bonusLimit={values.bonusLimit}
            wasPayoutPerConversionChanged={wasPayoutPerConversionChanged}
            payoutPerConversion={values.payoutPerConversion}
            wasBonusThresholdChanged={wasBonusThresholdChanged}
            bonusThreshold={values.bonusThreshold}
          />
        ),
        confirmDisabled: true,
        confirmLabel: 'Confirm',
        submitButtonCypressId: 'confirm-bonus-changes',
      })
    }

    return handleSubmit()
  }

  const triggerDMAssetRegeneration = async ({
    campaignId,
    subtype,
    oldStartDate,
    newStartDate,
  }) => {
    try {
      const isAdm = subtype === CAMPAIGN_SUBTYPES_ENUM.ADM
      const token = authorization.getAPIKey()
      const url = `${CONFIG.API_BASE_URL}/campaigns/us/direct-mail${
        isAdm ? '/adm' : '/eddm'
      }/${campaignId}/trigger-presort-asset-regeneration`

      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
          'X-api-key': token,
        },
        body: JSON.stringify({
          oldLaunchDate: format(oldStartDate, 'DD/MM/YYYY'),
          newLaunchDate: format(newStartDate, 'DD/MM/YYYY'),
        }),
      })
      const result = await response.json()

      if (!response.ok) {
        throw new Error(
          result.message || 'Failed to trigger DMAssetRegeneration',
        )
      }

      return result
    } catch (error) {
      console.error('Error triggering DMAssetRegeneration', error)
    }
  }

  const existingBoundaries = useMemo(() => {
    if (isH2HType || !editMode) return []
    if (!props.missions || !props.missions.length) return []

    const allOverlays = Object.values(
      getInitialOverlaysMapFromMissions(props.missions, {
        isClient: isClient(),
        clickable: false,
      }),
    )
      .map(node => ({
        ...node,
        color: '#bdbdbd',
        boundary: node.paths[0].map(item => ({
          longitude: item.lng,
          latitude: item.lat,
        })),
      }))
      .filter(node => node.paths[0][0] && node.paths[0][0].lng)

    return allOverlays
  }, [
    isH2HType,
    editMode,
    props.campaign && props.campaign.cityPlans,
    props.missions,
  ])

  const getOverlaysForQuote = () => {
    if (isH2HType) return null
    const newOverlays = Object.values(overlaysMap || {}).map(overlay => ({
      id: overlay.customId,
      boundary: getOverlayBoundary(overlay),
    }))
    return [...(existingBoundaries || []), ...newOverlays]
  }

  const campaignsOverlays = useMemo(getOverlaysForQuote, [
    existingBoundaries,
    overlaysMap,
  ])

  const getCampaignCountryActiveCities = () =>
    cities.filter(
      city =>
        city.country.code === country.code &&
        city.statusV2 === CITY_STATUS_ENUM_ACTIVE,
    )

  const getCampaignCountryCities = () =>
    cities.filter(city => city.country.code === country.code)

  const campaignCountryAllCities = useMemo(getCampaignCountryCities, [
    country.code,
    cities,
  ])

  const campaignCountryCities = useMemo(getCampaignCountryActiveCities, [
    country.code,
    cities,
  ])

  // eslint-disable-next-line

  const [isPrintingPlanLoading, setIsPrintingPlanLoading] = useState(false)

  const onExportPrintingPlanClick = async () => {
    setIsPrintingPlanLoading(true)

    await exportComponentAsPDF({
      renderContent: ({ onInit }) => (
        <CampaignPrintingPlan>
          <CampaignQuote
            overlays={campaignsOverlays}
            metrics={[]}
            printingCostPerFlyer={
              typeof printingCostPerFlyer == 'string'
                ? convertMonetaryDollarStringToCentValue(printingCostPerFlyer)
                : printingCostPerFlyer
            }
            distributionCost={
              typeof distributionCost == 'string'
                ? convertMonetaryDollarStringToCentValue(distributionCost)
                : distributionCost
            }
            bonusEnabled={bonusEnabled}
            bonusLimit={
              typeof bonusLimit == 'string'
                ? convertMonetaryDollarStringToCentValue(bonusLimit)
                : bonusLimit
            }
            payoutPerConversion={
              typeof payoutPerConversion == 'string'
                ? convertMonetaryDollarStringToCentValue(payoutPerConversion)
                : payoutPerConversion
            }
            cities={campaignCountryCities}
            country={country}
            hideColumns={[
              'Density',
              '# Missions',
              'Total Dist Cost',
              'Total Printing Cost',
              'Bonus Cost',
              'Total',
            ]}
            simpleView
            onDataLoaded={onInit} //Initialize printing when table is loaded
          />
        </CampaignPrintingPlan>
      ),
      delayedRender: true,
      title: 'Campaign printing plan',
    })
    setIsPrintingPlanLoading(false)
  }

  const onExpirationClick = () => {
    setNoExpiration(!noExpirationState)
    setValue('offerExpirationDate', null)
  }

  const handleSkipPayment = async () => {
    try {
      const response = await updateCampaignExtraData({
        campaignId: props.campaign.id,
        isPaymentSkipped: true,
        paymentSkipperId: user.id,
      })
      const { data: result } = await response.json()

      if (
        result.updateCampaignExtraData &&
        result.updateCampaignExtraData.success
      ) {
        await insertCampaignLogs([
          {
            campaignId: props.campaign.id,
            type: CAMPAIGN_LOG_ENUM_TYPES.SKIP_PAYMENT,
            additionalInfo: `from ${false} to ${true}`,
          },
        ])

        setPaymentSkippedBy(`${user.firstName} ${user.lastName}`)
        setIsPaymentSkipped(true)
      }
    } catch (error) {}
  }

  const handleSkipPaymentClick = () => {
    if (isPaymentSkipped || !props.campaign || !props.campaign.id) {
      return
    }

    const { showReduxModal } = props

    return showReduxModal({
      title: 'Skip Stripe Checkout',
      children: <span>This action can not be reverted.</span>,
      onConfirm: handleSkipPayment,
      confirmLabel: 'Confirm',
      submitButtonCypressId: 'payment-skip-confirm-button',
    })
  }

  const validateCityMetricDto = d => {
    const citiesNames = campaignCountryAllCities.map(item =>
      item.name.toUpperCase(),
    )

    const errors = Object.entries(d).reduce((acc, item) => {
      const [key, value] = item

      if (!['CITY_NAME'].includes(key) && isNaN(value)) {
        acc.push(`Wrong format ${key} - ${value}`)
      }

      return acc
    }, [])

    if (errors.length) {
      const error = errors[0]
      throw new Error(error)
    }
    if (type === CAMPAIGN_ENUM_TYPES.DIRECTMAIL) {
      if (!d['POSTING_COST']) throw new Error('Missing Posting Cost.')
      if (!d['DATA_COST']) throw new Error('Missing Data Cost')
    } else {
      if (!d['TOTAL_MISSIONS']) throw new Error('Missing Total Missions.')
      if (!d['DISTRIBUTION_COST']) throw new Error('Missing Distribution Cost.')
    }

    if (!d['CITY_NAME']) throw new Error('Missing City Name.')
    if (!d['TOTAL_FLYERS']) throw new Error('Missing Total Flyers.')
    if (!citiesNames.includes(d['CITY_NAME'].toUpperCase()))
      throw new Error('Wrong city')
  }

  const downloadCsv = () => {
    if (type === CAMPAIGN_ENUM_TYPES.DIRECTMAIL) {
      downloadStringAsFile(
        `CITY_NAME,TOTAL_FLYERS,PRINTING_COST,DATA_COST,POSTING_COST,FREIGHT_COST
New York City,3000,1460,500,1665.27,122`,
        `example-city-metrics.csv`,
      )
    } else {
      downloadStringAsFile(
        `CITY_NAME,TOTAL_FLYERS,TOTAL_MISSIONS,DISTRIBUTION_COST,TRAVEL_COST,PERMIT_COST,PRINTING_COST,OUTFIT_COST,BONUS_BUDGET
New York City,3000,2,960,0,0,1665.27,41.2,551.2`,
        `example-city-metrics.csv`,
      )
    }
  }

  const onImportSuccess = data => {
    const citiesHashMap = campaignCountryAllCities.reduce((acc, city) => {
      acc[city.name.toUpperCase()] = Number(city.id)

      return acc
    }, {})

    const convertToNumber = value =>
      !value || Number(value) == 0 ? null : Number(value)
    const result = data.reduce((acc, item, index) => {
      const cityId = citiesHashMap[item.CITY_NAME.toUpperCase()]

      acc.push({
        id: `newCity-${index + 1}`,
        cityId,
        totalFlyers: convertToNumber(item.TOTAL_FLYERS),
        totalMissions: convertToNumber(item.TOTAL_MISSIONS),
        distributionCost: convertToNumber(item.DISTRIBUTION_COST),
        travelCost: convertToNumber(item.TRAVEL_COST),
        permitCost: convertToNumber(item.PERMIT_COST),
        printingCost: convertToNumber(item.PRINTING_COST),
        postingCost: convertToNumber(item.POSTING_COST),
        dataCost: convertToNumber(item.DATA_COST),
        outfitCost: convertToNumber(item.OUTFIT_COST),
        bonusBudget: convertToNumber(item.BONUS_BUDGET),
        freightCost: convertToNumber(item.FREIGHT_COST),
      })
      return acc
    }, [])

    setUploadedCityMetrics(result)
    setShowImportCityMetricModal(false)
  }

  const handleCreateItem = async () => {
    setIsTenantLoading(true)
    await onCreateXeroItem({
      campaign: props.campaign,
      countryCode: country.code,
      tenantId: tenant.tenantId,
    })
    setRefetchTenant(true)
  }

  const getXeroTenant = async () => {
    setIsTenantLoading(true)

    try {
      const tenant = await apiXero.getXeroTenant()

      if (tenant && tenant.isAuthorized && tenant.isConnected) {
        let data = { ...tenant }

        const tenantId = tenant.tenantId

        if (client) {
          const dataContact = await apiXero.getXeroContact({
            tenantId,
            contactName: client.name,
            contactId: client.id,
          })

          if (dataContact.isExist) {
            const contact = dataContact.contact

            data.contact = contact

            if (props.campaign) {
              const dataItem = await apiXero.getXeroItem({
                tenantId,
                campaignId: props.campaign.id,
                contactID: contact.contactID,
              })

              if (dataItem.isExist) {
                const item = dataItem.item
                data.item = item

                if (item.invoice) {
                  data.invoice = item.invoice
                }
              }
            }
          }
        }

        setTenant(data)
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log({ error })
    } finally {
      setIsTenantLoading(false)
    }
  }

  const onCreateOrUpdateInvoice = async () => {
    if (!citiesMetricsValues.length) {
      return props.showReduxModal({
        title: 'Validation Error',
        children: <span>Upload City Metric Please</span>,
        hideCancel: true,
        confirmLabel: 'OK',
      })
    }

    const { ifCityMetricsDifferent } = checkIsCityMetricsDifferent({
      newCityMetrics: citiesMetricsValues,
      oldCityMetrics: props.campaignCityMetrics,
    })

    if (ifCityMetricsDifferent) {
      return props.showReduxModal({
        title: 'Validation Error',
        children: (
          <span>
            After upload City Metric to Xero. You need save this City Metrics in
            Campaign
          </span>
        ),
        hideCancel: true,
        confirmLabel: 'OK',
      })
    }

    setIsTenantLoading(true)

    if (tenant.invoice) {
      await apiXero.updateXeroInvoice({
        itemCode: tenant.item.code,
        campaignId: props.campaign.id,
        tenantId: tenant.tenantId,
        invoiceID: tenant.invoice.invoiceID,
        contactID: tenant.contact.contactID,
        clientName: client.name,
      })
    } else {
      await apiXero.createXeroInvoice({
        itemCode: tenant.item.code,
        campaignId: props.campaign.id,
        tenantId: tenant.tenantId,
        contactID: tenant.contact.contactID,
        clientName: client.name,
      })
    }

    setRefetchTenant(true)
  }

  const disabledEditCityMetrics = (!tenant || tenant.invoice) && isSelfServe

  const setBonusEnabled = value => {
    if (value) {
      setValues(values => ({
        ...values,
        bonusEnabled: value,
        bonusThreshold: 3,
      }))
    } else {
      setValues(values => ({
        ...values,
        bonusEnabled: value,
        bonusThreshold: '',
      }))
    }
  }

  const affiliateClients = useMemo(() => {
    if (!clientId) {
      return []
    }

    const selectedAffiliateIds = affiliateMetricsValues
      .filter(metric => metric.clientId)
      .map(metric => metric.clientId)

    return clients.filter(
      client =>
        client.isAffiliate &&
        client.id !== clientId &&
        !selectedAffiliateIds.includes(client.id) &&
        client.countryId === parseInt(countryId, 10),
    )
  }, [clients, affiliateMetricsValues, clientId, countryId])

  return (
    <form className={props.className}>
      <Modal show={showImportCityMetricModal}>
        <ImportCityMetrics
          onImportSuccess={onImportSuccess}
          validateRow={validateCityMetricDto}
          downloadSampleCSV={downloadCsv}
          onClose={() => setShowImportCityMetricModal(false)}
        />
      </Modal>
      <SectionWrapper className="section-wrapper">
        <SectionTitle className="section-title">Campaign Type</SectionTitle>
        <div className="type-buttons">
          <ButtonGroup disableElevation color="primary" disabled={editMode}>
            <SubmitButton
              value="Hand to hand"
              variant={isH2HType ? 'contained' : 'outlined'}
              onClick={() => setValue('type', CAMPAIGN_ENUM_TYPES.HANDTOHAND)}
              cypress_id="h2h-campaign-type-button"
            />
            <SubmitButton
              value="Letterbox"
              variant={isD2DType ? 'contained' : 'outlined'}
              onClick={() => setValue('type', CAMPAIGN_ENUM_TYPES.LETTERBOX)}
              cypress_id="lb-campaign-type-button"
            />
            <SubmitButton
              value="Direct Mail"
              variant={isDMType ? 'contained' : 'outlined'}
              onClick={() => setValue('type', CAMPAIGN_ENUM_TYPES.DIRECTMAIL)}
              cypress_id="dm-campaign-type-button"
            />
            {isAimFeatureEnabled && (
              <SubmitButton
                value="Inserts"
                style={{ width: '120px' }}
                variant={isAIMType ? 'contained' : 'outlined'}
                onClick={() => setValue('type', CAMPAIGN_ENUM_TYPES.INSERTS)}
                cypress_id="aim-campaign-type-button"
              />
            )}
          </ButtonGroup>
          <ErrorMessage>{errors['type']}</ErrorMessage>
        </div>
      </SectionWrapper>
      <SectionWrapper className="section-wrapper">
        <Row>
          <SectionTitle className="section-title-inline">
            Campaign Details
          </SectionTitle>
          {isD2DType && isPathFinderSupportsCountry(country.code) ? (
            <React.Fragment>
              <div className="printing-plan-btns">
                <SubmitButton
                  className={isPrintingPlanLoading ? 'transparent' : ''}
                  type="Button"
                  value="Export Printing plan"
                  onClick={onExportPrintingPlanClick}
                  disabled={isPrintingPlanLoading}
                />
              </div>
            </React.Fragment>
          ) : null}
        </Row>
        <Row>
          <Col xs={6}>{renderCountrySelect()}</Col>
          <Col xs={6}>{renderClientSelect()}</Col>
        </Row>
        <Row>
          <Col xs={6}>
            <Input
              type="text"
              label="Name*"
              value={name}
              onChange={e => setValue('name', e.target.value)}
              error={errors['name']}
              cypress_id="create-campaign-name-input"
            />
          </Col>
          <Col xs={6}>
            <Input
              className={`input-with-icon  ${getCurrencyInputClass()}`}
              type="number"
              label="Printing cost per flyer*"
              value={printingCostPerFlyer}
              onChange={e => setValue('printingCostPerFlyer', e.target.value)}
              error={errors['printingCostPerFlyer']}
              cypress_id="create-campaign-printing_cost_per_flyer-input"
              disabled={isSelfServe}
            />
          </Col>
        </Row>
        <Row>
          {editMode && <Col xs={6}>{renderStatusSelect()}</Col>}
          {!disableBAFeatures && (
            <Col xs={6}>
              <Slider
                unit="weeks"
                label="Redemption Time"
                min={2}
                max={6}
                defaultValue={baRedemptionPeriod}
                value={baRedemptionPeriod}
                onChange={value => setValue('baRedemptionPeriod', value)}
                error={errors['baRedemptionPeriod']}
              />
            </Col>
          )}
        </Row>

        <Row>
          <Col xs={6}>
            <div className="inputHeader">
              <span className={'label'}>Start date*</span>
              <span className={'errorLabel'}>{errors['startDate']}</span>
            </div>
            <div style={{ position: 'relative', width: '100%' }}>
              <DatePicker
                ref={startDatePickerRef}
                hintText="Select start date"
                value={startDate || null}
                onChange={(event, date) => setValue('startDate', date)}
                formatDate={date => {
                  if (!date) return ''
                  const year = date.getFullYear()
                  const month = String(date.getMonth() + 1).padStart(2, '0')
                  const day = String(date.getDate()).padStart(2, '0')
                  return `${day}/${month}/${year}`
                }}
                shouldDisableDate={date => {
                  const today = new Date()
                  today.setHours(0, 0, 0, 0)
                  if (date < today) return true

                  const dayOfWeek = date.getDay()
                  return dayOfWeek === 0 || dayOfWeek === 6
                }}
                minDate={new Date()}
                textFieldStyle={{
                  backgroundColor: '#f8f8f8',
                  width: '100%',
                  height: 52,
                  paddingLeft: 16,
                  paddingRight: 40,
                  border: errors['startDate'] ? '1px solid red' : null,
                  borderRadius: 4,
                }}
                underlineShow={false}
              />
              <CalendarIcon
                onClick={() => {
                  if (startDatePickerRef.current) {
                    startDatePickerRef.current.openDialog()
                  }
                }}
                style={{
                  position: 'absolute',
                  right: 12,
                  top: '50%',
                  transform: 'translateY(-50%)',
                  width: 20,
                  height: 20,
                  fill: '#666',
                  cursor: 'pointer',
                }}
              />
            </div>
          </Col>
          {!isDMType && (
            <Col xs={6}>
              <Input
                type="number"
                label="Campaign duration, weeks*"
                value={campaignDurationWeek}
                min={1}
                onChange={e =>
                  setValue('campaignDurationWeek', Number(e.target.value))
                }
                error={errors['campaignDurationWeek']}
              />
            </Col>
          )}
        </Row>

        {editMode && props.campaign && isUSDMSubtype && (
          <Row>
            <Col xs={12}>
              <div className="asset-generation-warning">
                If assets were already generated, changing the date will trigger
                a new asset generation.
              </div>
            </Col>
          </Row>
        )}

        <Row>
          <Col xs={6} style={{ opacity: noExpirationState ? 0 : 1 }}>
            <div className="inputHeader">
              <span className={'label'}>Offer expiration date*</span>
              <span className={'errorLabel'}>
                {errors['offerExpirationDate']}
              </span>
            </div>

            {noExpirationState ? null : (
              <TextField
                type={'date'}
                name="Offer expiration date*"
                format="DD/MM/YYYY"
                underlineShow={false}
                style={{
                  backgroundColor: '#f8f8f8',
                  width: '100%',
                  height: 52,
                  paddingLeft: 16,
                  border: errors['offerExpirationDate']
                    ? '1px solid red'
                    : null,
                  borderRadius: 4,
                }}
                inputStyle={{ width: '98%' }}
                onChange={e => {
                  if (e.target.value) {
                    const splittesValue = e.target.value.split('-')
                    const formattedValue = `${splittesValue[0].slice(0, 4)}-${
                      splittesValue[1]
                    }-${splittesValue[2]}`
                    setValue('offerExpirationDate', new Date(formattedValue))
                  }
                }}
                value={
                  offerExpirationDate
                    ? new Date(offerExpirationDate).toISOString().split('T')[0]
                    : null
                }
                error={errors['offerExpirationDate']}
              />
            )}
          </Col>
          <Col xs={3}>
            <div className={'checkBoxContainer'} onClick={onExpirationClick}>
              <SquareCheckBox active={noExpirationState} />
              <span className={'checkBoxTitle'}>No expiration date</span>
            </div>
          </Col>
          {isSelfServe && (
            <Col xs={3}>
              <div
                style={
                  !isDraft || isPaymentSkipped
                    ? { opacity: 0.4, pointerEvents: 'none' }
                    : null
                }
                className={'checkBoxContainer'}
                onClick={handleSkipPaymentClick}
              >
                <SquareCheckBox active={isPaymentSkipped} />
                <span className={'checkBoxTitle'}>
                  {isPaymentSkipped
                    ? `Skip Stripe Checkout was authorized by ${paymentSkippedBy}`
                    : 'Skip Stripe Checkout'}
                </span>
              </div>
            </Col>
          )}
        </Row>
        <Row>
          <Col xs={6}>
            <SelectDashboard
              onChange={(a, b, value) => setValue('goal', value)}
              options={GOAL_CAMPAIGN_OPTIONS}
              label="Campaign Goal"
              value={goal}
              input={{
                multiple: true,
              }}
              cypress_id="edit-campaign-goal-select"
            />
          </Col>
          <Col xs={6}>
            <Input
              type="text"
              label="Purchase Order Number"
              value={purchaseOrderNumber}
              onChange={e => setValue('purchaseOrderNumber', e.target.value)}
              error={errors['purchaseOrderNumber']}
            />
          </Col>
        </Row>
      </SectionWrapper>

      {CampaignFeaturesConfig(type).cityMetrics !==
      cityMetricsTypes.affiliates ? (
        <SectionWrapper className="section-wrapper">
          <SectionTitle className="section-title">City Metrics</SectionTitle>
          <SectionLabel>
            For the costs fields, please provide total cost for all missions in
            the city, not cost per mission.
          </SectionLabel>
          <CityMetricTable
            campaignData={initialValues}
            cities={campaignCountryAllCities}
            currencySign={currencySign}
            citiesMetrics={props.campaignCityMetrics}
            citiesMetricsValues={citiesMetricsValues}
            setCitiesMetricsValues={setCitiesMetricsValues}
            uploadedCityMetrics={uploadedCityMetrics}
            disabled={disabledEditCityMetrics}
          />
          {!disabledEditCityMetrics ? (
            <Row>
              <Col
                xs={12}
                style={{
                  paddingTop: '36px',
                  display: 'flex',
                  justifyContent: 'flex-end',
                }}
              >
                <SubmitButton
                  value="Upload CSV"
                  id="Upload CSV-submitButton"
                  disabled={props.loading}
                  onClick={() => setShowImportCityMetricModal(true)}
                />
              </Col>
            </Row>
          ) : null}
        </SectionWrapper>
      ) : (
        <SectionWrapper className="section-wrapper">
          <SectionTitle className="section-title">
            Affiliate Metrics
          </SectionTitle>
          <SectionLabel>
            For the cost fields, please provide the total cost for all flyer
            packs in that affiliate, not the cost per pack.
          </SectionLabel>
          <SectionLabel>
            Enter inserts in multiples of 500 (500 = 1 pack).
          </SectionLabel>
          <AffiliateMetricTable
            campaignData={initialValues}
            affiliateClients={affiliateClients}
            currencySign={currencySign}
            setAffiliateMetricsValues={setAffiliateMetricsValues}
            affiliateMetricsValues={affiliateMetricsValues}
            disabled={disableEditAffiliateMetrics}
          />
        </SectionWrapper>
      )}

      {isUnitedStatesCoreDM &&
        props.campaign &&
        !props.campaign.isSelfServe && (
          <CampaignShipmentUpload
            campaignId={props.campaign.id}
            shipmentUploaded={() => getCampaignCityMetricsData()}
          />
        )}
      {!disableBAFeatures && (
        <SectionWrapper
          className={`section-wrapper ${bonusDisabled ? 'disabled' : ''}`}
          style={{ overflow: 'initial' }}
        >
          <div className="bonus-title-container">
            <SectionTitle className="section-title">
              Conversion Bonus
            </SectionTitle>
            {!bonusSwitchDisabled && (
              <Switch
                value={bonusEnabled}
                input={{
                  onChange: e => setBonusEnabled(e.target.checked),
                }}
                cypress_id="create-campaign-enable_conversion_bonus-switch"
              />
            )}
          </div>
          <div className="bonus-container">
            <div className="left-box">
              <Input
                disabled={!bonusEnabled || bonusDisabled}
                className={`input-with-icon ${getCurrencyInputClass()}`}
                placeholder="Bonus allowance"
                type="number"
                label="Bonus Allowance*"
                value={bonusLimit}
                onChange={e => setValue('bonusLimit', e.target.value)}
                error={errors['bonusLimit']}
                cypress_id="create-campaign-bonus_allowance-input"
              />
            </div>
            <div className="right-box">
              <Input
                disabled={!bonusEnabled || bonusDisabled}
                className={`input-with-icon ${getCurrencyInputClass()}`}
                placeholder="Bonus Per Conversion"
                type="number"
                label="Bonus Per Conversion*"
                value={payoutPerConversion}
                onChange={e => setValue('payoutPerConversion', e.target.value)}
                error={errors['payoutPerConversion']}
                cypress_id="create-campaign-bonus_per_conversion-input"
              />
            </div>
          </div>
          <div className="bonus-container" style={{ marginTop: '20px' }}>
            <div className="left-box">
              <Input
                useExternalValue={true}
                disabled={!bonusEnabled || bonusDisabled}
                className={`input-with-icon input-with-icon_percent`}
                placeholder="Leak Protection Threshold"
                type="number"
                label="Leak Protection Threshold*"
                value={bonusThreshold}
                input={{ value: bonusThreshold }}
                onChange={e => setValue('bonusThreshold', e.target.value)}
                content="Set a threshold for bonus payments, linked to the mission's primary metric CVR. If a mission meets or exceeds this threshold, all conversions from that upload batch for that specific mission will be disqualified from bonus payments.
If you leave this field blank, no bonus threshold will be applied."
              />
            </div>
            <div className="right-box" />
          </div>
        </SectionWrapper>
      )}

      <SectionWrapper className="section-wrapper metrics">
        <SectionTitle className="section-title">Campaign Metrics</SectionTitle>
        {(() => {
          const isWaveCampaign =
            props.campaign &&
            props.campaign.workflow &&
            props.campaign.workflow.uuid

          if (isWaveCampaign) {
            return <MetricsInWorkflow campaign={props.campaign} />
          } else {
            return (
              <MetricsEdit
                defaultMetrics={props.defaultMetrics}
                metrics={props.metrics}
                campaign={props.campaign}
                onMetricUpdate={props.onMetricUpdate}
                onMetricDelete={props.onMetricDelete}
                onMetricAdd={props.onMetricAdd}
                primaryIndex={props.primaryMetricIndex}
                onPrimaryIndexChange={props.onPrimaryMetricIndexChange}
                conversionToggle={conversionToggle}
                setCanMetricEdit={setCanMetricEdit}
                canMetricEdit={canMetricEdit}
                scansToggle={scansToggle}
                toggleConversionApi={toggleConversionApi}
                toggleScans={toggleScans}
                flyerCodeToggle={flyerCodeToggle}
                toggleFlyerCode={toggleFlyerCode}
              />
            )
          }
        })()}
      </SectionWrapper>

      <SectionWrapper className="section-wrapper">
        <SectionTitle className="section-title">Targeting</SectionTitle>
        <CampaignTargetingEdit
          targeting={{
            targetType,
            targetGender,
            targetIncome,
            targetAgeGroups,
            applyNicheTargeting,
            nicheTargetingDescription,
          }}
          setValue={setValue}
          errors={errors}
        />
      </SectionWrapper>
      {!disableBAFeatures && authorization.isAdmin() && props.campaign ? (
        <SectionWrapper className="section-wrapper metrics">
          <SectionTitle className="section-title">Actions</SectionTitle>
          <Checkbox
            input={{
              value: receiveReport,
              onClick: toggleReceiveReport,
            }}
            label="Receive Report"
          />
        </SectionWrapper>
      ) : null}

      {isD2DType && isPathFinderSupportsCountry(country.code) && (
        <React.Fragment>
          <CampaignQuote
            overlays={campaignsOverlays}
            metrics={props.metrics}
            printingCostPerFlyer={
              typeof printingCostPerFlyer == 'string'
                ? convertMonetaryDollarStringToCentValue(printingCostPerFlyer)
                : printingCostPerFlyer
            }
            distributionCost={
              typeof distributionCost == 'string'
                ? convertMonetaryDollarStringToCentValue(distributionCost)
                : distributionCost
            }
            bonusEnabled={bonusEnabled}
            bonusLimit={
              typeof bonusLimit == 'string'
                ? convertMonetaryDollarStringToCentValue(bonusLimit)
                : bonusLimit
            }
            payoutPerConversion={
              typeof payoutPerConversion == 'string'
                ? convertMonetaryDollarStringToCentValue(payoutPerConversion)
                : payoutPerConversion
            }
            cities={campaignCountryCities}
            country={country}
          />
          <SectionWrapper className="section-wrapper">
            <SectionTitle>Campaign Map</SectionTitle>
            {country.code ? (
              <CampaignBuilderMap
                loading={props.loading}
                countryCode={country.code}
                onUpdate={value => setValue('overlaysMap', value)}
                existingBoundaries={existingBoundaries}
                cities={cities}
                prebuiltOverlays={prebuiltOverlays}
              />
            ) : (
              'Please, select a country first'
            )}
          </SectionWrapper>
        </React.Fragment>
      )}
      {authorization.isAdmin() && isXeroAvailable && !disableXeroInvoice ? (
        <SectionWrapper className="section-wrapper metrics">
          <SectionTitle className="section-title">Xero</SectionTitle>
          {isTenantLoading ? (
            'Loading...'
          ) : (
            <div
              style={{
                display: 'flex',
                alignItems: 'flex-start',
                justifyContent: 'space-between',
              }}
            >
              <div style={{ display: 'flex' }}>
                <div
                  style={{
                    marginRight: 60,
                  }}
                >
                  <div style={{ marginBottom: '10px' }}>
                    Entity: {tenant ? tenant.name : '-'}
                  </div>
                  <XeroConnected isConnected={tenant} />
                </div>
                <div
                  style={{
                    marginRight: 60,
                  }}
                >
                  <div style={{ marginBottom: '10px' }}>
                    Country code: {tenant ? tenant.countryCode : '-'}
                  </div>
                  <div style={{ marginBottom: '10px' }}>
                    Base currency: {tenant ? tenant.baseCurrency : '-'}
                  </div>
                  <div>
                    Item Code: {tenant && tenant.item ? tenant.item.code : '-'}
                  </div>
                </div>
                <div>
                  <div style={{ marginBottom: '10px' }}>
                    Account number:{' '}
                    {!tenant ? (
                      '-'
                    ) : tenant.contact ? (
                      tenant.contact.accountNumber
                    ) : props.campaign ? (
                      <span>
                        Not existing contact in Xero. Client ID:{' '}
                        <a
                          href={`/dashboard/clients/${clientId}/edit`}
                          target="_blank"
                          rel="noreferrer"
                        >
                          {props.campaign.client.id}
                        </a>
                      </span>
                    ) : (
                      ''
                    )}
                  </div>
                  <div style={{ marginBottom: '10px' }}>
                    Contact default currency:{' '}
                    {!tenant || !tenant.contact
                      ? '-'
                      : tenant.contact.defaultCurrency}
                  </div>
                  <div>
                    Campaign invoice number:{' '}
                    {!tenant || !tenant.invoice
                      ? '-'
                      : tenant.invoice.invoiceNumber}
                  </div>
                </div>
              </div>
              {editMode ? (
                !tenant ? (
                  <SubmitButton
                    value="Go to Xero settings"
                    onClick={() => {
                      openLinkInNewTab(
                        `${PATHS.main.dashboard}${PATHS.dashboard.settings}${
                          PATHS.settings.xeroConnection
                        }`,
                      )
                    }}
                  />
                ) : tenant && !tenant.item ? (
                  <SubmitButton
                    value="Create Item"
                    disabled={
                      !tenant ||
                      !tenant.contact ||
                      !tenant.contact.accountNumber
                    }
                    onClick={handleCreateItem}
                  />
                ) : (
                  <SubmitButton
                    value={tenant.invoice ? 'Edit Invoice' : 'Create Invoice'}
                    disabled={
                      !tenant ||
                      !tenant.contact ||
                      !tenant.contact.accountNumber
                    }
                    onClick={onCreateOrUpdateInvoice}
                  />
                )
              ) : null}
            </div>
          )}
        </SectionWrapper>
      ) : null}
      <LaunchDateChangeDialog
        open={isLaunchDateModalOpen}
        onClose={() => setLaunchDateModalOpen(false)}
        onConfirm={() => {
          setLaunchDateModalOpen(false)
          handleSubmit()
        }}
      />
      <footer
        style={{
          display: 'flex',
          alignItems: 'flex-start',
          justifyContent: 'flex-end',
          float: 'right',
          width: '100%',
        }}
      >
        {props.loading && (
          <LoadingIndicator
            style={{
              flexDirection: 'row',
              width: 'unset',
              height: 'unset',
              marginRight: '24px',
            }}
            labelStyle={{ marginTop: '0', marginLeft: '8px' }}
            label={props.loadingLabel}
            size={35}
          />
        )}

        <SubmitButton
          value={editMode ? 'Save campaign' : 'Create campaign'}
          id="CreateClient-submitButton"
          disabled={props.loading}
          onClick={onSubmit}
          cypress_id="create-campaign-submit-button"
        />
      </footer>
    </form>
  )
}

CreateEditCampaignFormUnstyled.propTypes = {
  clients: PropTypes.array.isRequired,
  canDeletePrimaryMetric: PropTypes.bool,
}

const mapStateToProps = state => ({
  countries: state.countries.countriesList,
})

const mapDispatchToProps = {
  showReduxModal,
  hideReduxModal,
  resetReduxModal,
  toggleConfirmAvailabilityReduxModal,
  getCountries,
  getCitiesRedux,
  updateClientById,
  getClients,
}

const CreateEditCampaignFormUnstyledFormConnected = connect(
  mapStateToProps,
  mapDispatchToProps,
)(CreateEditCampaignFormUnstyled)

export default CreateEditCampaignFormUnstyledFormConnected
